import { Badge } from 'antd';
import {
  Button,
  Col,
  Colors,
  IcChannel,
  IcInStore,
  IcMediaLibrary,
  IcPlus,
  IcScreen,
  IcUpload,
  Row,
  Text,
} from 'basic-ui-lib';
import NewScreenModal from 'modules/dashboard/screens/Create';
import UploadImageOrVideoModal, { UploadImageOrVideoModalRef } from 'modules/media/screens/Dashboard/LibraryList/UploadImageOrVideoModal';
import { NewStoreModal, useNewStoreModalRef } from 'modules/store/screens/Create';
import React, { useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const quickActions = [
  {
    key: 'add_new_screen',
    label: 'Add New Screen',
    icon: <IcPlus width={16} height={16} fill={Colors.neutral.text[3]} />,
  },
  { key: 'add_store', label: 'Add Store', icon: <IcPlus width={16} height={16} fill={Colors.neutral.text[3]} /> },
  {
    key: 'upload_media',
    label: 'Upload Media',
    icon: <IcUpload width={16} height={16} fill={Colors.neutral.text[3]} />,
  },
];

const navigations = [
  {
    label: 'Stores',
    icon: <IcInStore width={16} height={16} fill={Colors.neutral.text[3]} />,
    activeIcon: <IcInStore width={16} height={16} fill={Colors.neutral.bg[1]} />,
    path: '/store',
  },
  {
    label: 'Media Library',
    icon: <IcMediaLibrary width={16} height={16} fill={Colors.neutral.text[3]} />,
    activeIcon: <IcMediaLibrary width={16} height={16} fill={Colors.neutral.bg[1]} />,
    path: '/media',
  },
  {
    label: 'Playlists',
    icon: <IcChannel width={16} height={16} fill={Colors.neutral.text[3]} />,
    activeIcon: <IcChannel width={16} height={16} fill={Colors.neutral.bg[1]} />,
    path: '/playlist',
  },
  {
    label: 'Screens',
    icon: <IcScreen width={16} height={16} fill={Colors.neutral.text[3]} />,
    activeIcon: <IcScreen width={16} height={16} fill={Colors.neutral.bg[1]} />,
    path: '/screen',
  },
  // {
  //   label: 'Channels',
  //   icon: <IcChannel width={16} height={16} fill={Colors.neutral.text[3]} />,
  //   activeIcon: <IcChannel width={16} height={16} fill={Colors.neutral.bg[1]} />,
  //   path: '/channel',
  // },

];

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isNewScreenModalOpen, setIsNewScreenModalOpen] = useState(false);
  const newStoreModalRef = useNewStoreModalRef();
  const uploadImageOrVideoModalRef = useRef<UploadImageOrVideoModalRef>(null);
  
  const handleClickQuickAction = (actionKey: string) => {
    switch (actionKey) {
      case 'add_new_screen':
        setIsNewScreenModalOpen(true);
        break;
      case 'add_store':
        newStoreModalRef.current?.open();
        break;
      case 'upload_media':
        uploadImageOrVideoModalRef.current?.open('');
        break;
      default:
        break;
    }
  };

  return (
    <Container>
      <Col gap={6} width='100%'>
        <Text left caption_2 medium caplock color='neutral.text.4'>
          Navigation
        </Text>
        <Col gap={0}>
          {navigations.map((nav) => {
            const active = location.pathname.startsWith(nav.path);
            return (
              <QuickAction key={nav.path} onClick={() => navigate(nav.path)} className={active ? 'active' : ''}>
                {active ? nav.activeIcon : nav.icon}
                <Text body_1 medium color={active ? 'neutral.text.1' : 'neutral.text.3'}>
                  {nav.label}
                </Text>
              </QuickAction>
            );
          })}
        </Col>
      </Col>
      <Col gap={6} width='100%'>
        <Text left medium caption_2 caplock color='neutral.text.4'>
          Quick Actions
        </Text>
        <Col gap={0}>
          {quickActions.map((action) => (
            <QuickAction key={action.key} onClick={() => handleClickQuickAction(action.key)}>
              {action.icon}
              <Text body_1 medium color='neutral.text.3'>
                {action.label}
              </Text>
            </QuickAction>
          ))}
        </Col>
      </Col>
      <Col gap={6} width='100%'>
        <Text left medium caption_2 caplock color='neutral.text.4'>
          SYSTEM STATUS
        </Text>
        <Row justifyContent='space-between' alignItems='center'>
          <Text left body_1 regular color='neutral.text.5'>
            Active Screens
          </Text>
          <Row alignItems='center' gap={4}>
            <Badge dot color={Colors.secondary[4]} />
            <Text left body_1 medium color='neutral.text.5'>
              8/12
            </Text>
          </Row>
        </Row>
        <Row justifyContent='space-between' alignItems='center'>
          <Text left body_1 regular color='neutral.text.5'>
            Active Screens
          </Text>
          <Text left body_1 medium color='neutral.text.5'>
            8/12
          </Text>
        </Row>
      </Col>
      <Col gap={6} width='100%'>
        <Row justifyContent='space-between' alignItems='center'>
          <Text left medium caption_2 caplock color='neutral.text.4'>
            RECENT ACTIVITIES
          </Text>
          <Button type_ghost sm className='styled-button'>
            View All
          </Button>
        </Row>
        <Row alignItems='flex-start' gap={6}>
          <Badge dot color={Colors.secondary[4]} />
          <Col gap={2}>
            <Text left body_1 regular color='neutral.text.5'>
              Screen “Main Aloha display” connected
            </Text>
            <Text left caption_2 color='neutral.text.3'>
              2 hours ago
            </Text>
          </Col>
        </Row>
        <Row alignItems='flex-start' gap={6}>
          <Badge dot color={Colors.primary[6]} />
          <Col gap={2}>
            <Text left body_1 regular color='neutral.text.5'>
              Media upload completed
            </Text>
            <Text left caption_2 color='neutral.text.3'>
              5 hours ago
            </Text>
          </Col>
        </Row>
      </Col>
      <NewScreenModal
        open={isNewScreenModalOpen}
        onClose={() => setIsNewScreenModalOpen(false)}
      />
      <NewStoreModal ref={newStoreModalRef} />
      <UploadImageOrVideoModal ref={uploadImageOrVideoModalRef} />
    </Container>
  );
};

export default Sidebar;
const Container = styled.div`
  width: 240px;
  display: flex;
  flex-direction: column;
  padding: 24px 16px;
  background-color: ${Colors.neutral.bg[1]};
  gap: 24px;
  border-right: 1px solid ${Colors.neutral.border[1]};
  height: calc(100vh - 60px);
  padding-bottom: 24px;
  overflow-y: auto;
  .styled-button {
    padding: 0;
  }
`;

const QuickAction = styled.div`
  display: flex;
  align-items: center;
  padding: 11px 8px;
  gap: 12px;

  &:hover {
    background-color: ${Colors.neutral.bg[2]};
    cursor: pointer;
  }

  &.active {
    background-color: ${Colors.secondary[4]};
    border-radius: 4px;
  }
`;
